module.exports = __webpack_public_path__ + "static/img/video_arrow.04eb228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video_arrow.png
// module id = 557
// module chunks = 2 6 8